import React from 'react';
import 'video-react/dist/video-react.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Container } from './styles/Container.styled';
import {
  SectionVideoCard,
  SectionCaption,
  VideoPart,
  VideoImg,
  VideoContainer,
} from './styles/VideoTextCard.styled';
import { ButtonDiv, Button } from './styles/Button.styled';
import ImageCards from './ImageCards';

export default function ProjectList({ data, id, dir }) {
  return data.projects.map((project) => {
    const { title, description, videoUrl, featuredImage, gallery, website, backgroundColor } =
      project.content;
    return (
      <SectionVideoCard
        id={id}
        backgroundColor={backgroundColor}
        className="project-list"
        dir={dir}
      >
        <Container className="project_videolist">
          <SectionCaption dir={dir}>
            <h2 dir={dir}>{title}</h2>
            <p dir={dir}>{description}</p>
          </SectionCaption>
          <VideoPart>
            {videoUrl ? (
              <VideoImg>
                <VideoContainer>
                  <iframe title="video" src={videoUrl} />
                </VideoContainer>
              </VideoImg>
            ) : (
              <VideoImg className="video_img">
                <LazyLoadImage
                  src={featuredImage && featuredImage.url}
                  alt=""
                  effect="blur"
                  placeholderSrc={featuredImage ? `${featuredImage.url}?width=50&quality=50` : null}
                />
              </VideoImg>
            )}
          </VideoPart>
        </Container>
        <ImageCards data={gallery} dir={dir} />
        <Container>
          {website && (
            <ButtonDiv className="btn_cta">
              <Button stylevariant="green" href={website.url} target="_blank" rel="" dir={dir}>
                {website.name}
              </Button>
            </ButtonDiv>
          )}
        </Container>
      </SectionVideoCard>
    );
  });
}
